import React, { useState, useEffect } from 'react';
import Firebase from 'Api/Firebase';
import { useHistory } from 'react-router-dom';
import { CardActions, Card, CardContent, CardMedia, Typography } from '@mui/material';
import Chip from 'Components/Chip';
import { ImageOutlined, PersonOutlineOutlined } from '@mui/icons-material';
import { colors } from 'Constants/Colors';
import { s3 } from 'Services/AWS/s3';
import { CardMain, chipStyle, CardMediaStyle, CardStyle, EmptyCardMediaStyle } from './style';

const mapCourse = course => [
  course.name,
  course?.description,
  course?.Priority?.name,
  course?.CourseCategory.name,
  course?.userCreated.fullName,
  course?.userCreated.photo,
  course?.thumbnail,
  course?.updatedAt,
  course?.isDraft === 'true',
  course?.expirationDate,
  course?.id,
];

export default function MediaControlCard({ course = [] }) {
  const { name, modules, members, thumbnail } = course;
  const [fetchedImage, setFetchedImage] = useState(null);
  const history = useHistory();

  useEffect(() => {
    let isMounted = true;
    if (thumbnail) {
      s3.getSignedUrl(thumbnail).then(data => {
        if (isMounted) {
          setFetchedImage(data?.signedUrl);
        }
      });
    }

    return () => {
      isMounted = false;
      setFetchedImage(null);
    };
  }, [course]);

  const navigationHandler = courseData => {
    history.push({
      pathname: '/cursos/detalles',
      state: {
        update: true,
        course: mapCourse(courseData),
        isComingFrom: '/dashboard',
      },
    });
  };

  return (
    <Card sx={CardStyle} onClick={() => navigationHandler(course)}>
      {fetchedImage ? (
        <CardMedia component="img" sx={CardMediaStyle} image={fetchedImage} />
      ) : (
        <div style={EmptyCardMediaStyle}>
          <ImageOutlined sx={{ width: 60, height: 60, color: colors.GRAY_DARK }} />
        </div>
      )}

      <div style={CardMain}>
        <CardContent>
          <Typography gutterBottom fontSize="1em">
            {name}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {modules?.length > 1
              ? `${modules.length} modulos`
              : `${modules.length} modulo${modules.length === 0 ? 's' : ''}`}
          </Typography>
        </CardContent>
        <CardActions style={{ display: 'flex', width: '100%' }}>
          <Chip style={chipStyle}>
            <PersonOutlineOutlined style={{ marginTop: '-.4rem' }} />
            {members}
          </Chip>
        </CardActions>
      </div>
    </Card>
  );
}
